import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
//Import Context
import { AppContext } from "../../../contexts/AppContext";
import staticData from '../../../contexts/staticData.json';
//Import Component
import RequestHistoryItemPayment from "./RequestHistoryItemPayment";
import ViewPaymentRequestForm from "../../viewPendingRequests/ViewPaymentRequestForm";
import ViewPurchaseRequestForm from '../../Forms/PurchaseForm/ViewPurchaseRequestForm';
import ViewFeeContractForm from "../../Forms/FeeContractForm/ViewFeeContractForm";
//Import Helpers
import { formatCurrency, formatDisplayName, getSubventionNames } from "../../../shared/helpers";
//Import Icons
import arrowSide from '../../../assets/icons/arrowSide.svg';
import documentIcon from '../../../assets/icons/document.svg';
//Import CSS
import './requestTracking.css';

function PaymentRequestTracking() {
    const location = useLocation();
    const navigate = useNavigate();
    const { establishment, returnState } = location.state || {};
    const { id } = useParams();
    const { requestsList, pmeList, establishmentList } = useContext(AppContext);
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [originalRequest, setOriginalRequest] = useState(null);
    const [activity, setActivity] = useState(null);
    const [showPaymentRequestForm, setShowPaymentRequestForm] = useState(false);
    const [showRequestForm, setShowRequestForm] = useState(false);

    useEffect(() => {
        if (id) {
            const findPaymentRequest = requestsList.find(request => request.id === id && request.typeOfRequest === 'payment');
            setPaymentRequest(findPaymentRequest);

            if (findPaymentRequest) {
                const findOriginalRequest = requestsList.find(request => request.id === findPaymentRequest.originRequestId);
                setOriginalRequest(findOriginalRequest);
                if (findOriginalRequest) {
                    const findPME = pmeList.find(pme => pme.id === findOriginalRequest.idPME);
                    if (findPME) {
                        const findActivity = findPME.activities.find(activity => activity.id === findOriginalRequest.idActivity);
                        setActivity(findActivity);
                    }
                }
            }
        }
    }, [requestsList, pmeList, id]);

    const returnHandler = (e) => {
        e.preventDefault();
        if (returnState) {
            navigate(returnState.previousPath, {
                state: {
                    ...returnState,
                    viewPaymentOpen: true,
                    currentRequestType: 'payment'
                }
            });
        } else {
            navigate(-1);
        }
    };

    const handleViewForm = () => {
        setShowPaymentRequestForm(true);
    };

    const handleCloseForm = () => {
        setShowPaymentRequestForm(false);
    };

    const handleViewPurchaseForm = () => {
        setShowRequestForm(true);
    };

    const handleClosePurchaseForm = () => {
        setShowRequestForm(false);
    };

    const renderBackupFiles = (backups) => {
        if (!backups || Object.keys(backups).length === 0) {
            return <p>No hay archivos de respaldo</p>;
        }

        return (
            <ul className="backup-files-list flex">
                {Object.entries(backups).map(([key, file]) => (
                    <li key={key}>
                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                            <img src={documentIcon} className="icon" alt="Icono de documento" />
                            {staticData.backupTypes[key] || key}
                        </a>
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <section className='container-activity-tracking flex'>
            <article className='info-request flex'>
                <h3>{establishment}</h3>
                <img src={arrowSide} className='icon' alt='Icono de flecha' />
                <p className='text-highlight'>Seguimiento de Solicitudes de Pago</p>
                <img src={arrowSide} className='icon' alt='Icono de flecha' />
                <p>{`Solicitud de Pago para Solicitud Folio Nº ${originalRequest?.requestDetails?.folio}`}</p>
            </article>
            {(showPaymentRequestForm && paymentRequest && activity) && (
                <ViewPaymentRequestForm
                    requestDetails={{ request: paymentRequest, activity: activity }}
                    establishmentList={establishmentList}
                    onClose={handleCloseForm}
                />
            )}
            {(showRequestForm && originalRequest && activity) && (
                originalRequest.typeOfRequest === 'feeContract'
                    ? <ViewFeeContractForm
                        onClose={handleClosePurchaseForm}
                        requestDetails={{ request: originalRequest, activity: activity }}
                        establishmentList={establishmentList}
                        fromViewPayment={true}
                    />
                    : <ViewPurchaseRequestForm
                        onClose={handleClosePurchaseForm}
                        requestDetails={{ request: originalRequest, activity: activity }}
                        establishmentList={establishmentList}
                        fromViewPayment={true}
                    />
            )}
            <article className='details-request payment flex'>
                <table>
                    <thead>
                        <tr>
                            <td>Nombre de la Acción</td>
                            <td>Subvención</td>
                            <td>Monto PME</td>
                            <td>Monto O.C / Contrato</td>
                            <td>Monto Solicitud de Pago</td>
                            <td>Tipo de Pago</td>
                            {(paymentRequest && paymentRequest.paymentType.value === 'partialPayment') && (
                                <td>Nº de Solicitudes</td>
                            )}
                            <td>Ver Form.</td>
                            <td>Ver Solicitud</td>
                        </tr>
                    </thead>
                    <tbody>
                        {(activity && originalRequest && paymentRequest) && (
                            <tr>
                                <th>{formatDisplayName(activity?.nameOfAction)}</th>
                                <th>{getSubventionNames(activity?.subsidies)}</th>
                                <th>{formatCurrency(activity?.totalSubsidyAmount)}</th>
                                <th>{formatCurrency(originalRequest.requestDetails?.purchaseOrderAmount)}</th>
                                <th>{formatCurrency(paymentRequest.amountToBePaid)}</th>
                                <th>{paymentRequest.paymentType.label}</th>
                                {(paymentRequest && paymentRequest.paymentType.value === 'partialPayment') && (
                                    <th>{paymentRequest.history.filter(hist => hist.action === 'Solicitud de Pago Creada' || hist.action === 'Solicitud de Pago Actualizada' || hist.action === 'Solicitud de Pago Reactivada').length}</th>
                                )}
                                <th><img src={documentIcon} className="icon" alt="Icono de documento" onClick={handleViewForm} /></th>
                                <th><img src={documentIcon} className="icon" alt="Icono de documento" onClick={handleViewPurchaseForm}/></th>
                            </tr>
                        )}
                    </tbody>
                </table>
            </article>
            <article className='request-history flex'>
                <p className='bold'>Historial de Solicitud de Pago</p>
                <article className='box-history flex'>
                    {paymentRequest && paymentRequest.history && paymentRequest.history.map((historyItem, index) => (
                        <RequestHistoryItemPayment
                            key={index}
                            historyItem={historyItem}
                            requestDetails={paymentRequest}
                            isPaymentRequest={true}
                        />
                    ))}
                </article>
            </article>
            <article className='box-button flex'>
                <button className='button' onClick={returnHandler}>Volver</button>
            </article>
        </section>
    );
};

export default PaymentRequestTracking;